const LOGO_SVG = `<svg width="64" height="64" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M27.1309 8.31348C28.6407 8.31348 30.1822 9.43651 31 10.5625H30.9864L19.1729 22.375C17.4239 24.124 14.5605 24.124 12.8116 22.375L11.6817 21.2441L22.3614 10.5625C22.3761 10.5433 22.7583 10.1702 22.7715 10.1572C23.8 9.17896 25.1594 8.31355 27.1309 8.31348ZM16.4356 8.31348C17.9454 8.31348 19.4869 9.43651 20.3047 10.5625L10.6534 20.2148L6.34087 15.9023L11.6797 10.5625C11.6967 10.5404 12.0648 10.1688 12.0762 10.1572C13.1047 9.17893 14.464 8.3135 16.4356 8.31348ZM5.76958 8.31348C7.27863 8.31352 8.82085 9.43653 9.63872 10.5625L5.31939 14.8818L1.00005 10.5625C0.994867 10.5507 1.40013 10.1668 1.41021 10.1572C2.43874 9.17892 3.79797 8.31348 5.76958 8.31348Z" fill="#FA4616" fill-rule="evenodd" clip-rule="evenodd"/>
</svg>`;

const BASE_STYLES = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body {
    font-family: -apple-system, BlinkMacSystemFont, "Inter", "Segoe UI", sans-serif;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fcfcfc;
    color: #202020;
  }
  .card {
    background: #ffffff;
    border: 1px solid #e8e8e8;
    border-radius: 16px;
    padding: 48px 40px;
    width: 100%;
    max-width: 360px;
    text-align: center;
    box-shadow: 0 1px 2px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.04);
  }
  .logo { margin-bottom: 24px; }
  h1 {
    font-size: 17px;
    font-weight: 600;
    letter-spacing: -0.02em;
    margin-bottom: 6px;
  }
  p { font-size: 13px; color: #646464; line-height: 1.5; }
  @media (prefers-color-scheme: dark) {
    body { background: #111111; color: #eeeeee; }
    .card { background: #191919; border-color: #2a2a2a; box-shadow: 0 1px 2px rgba(0,0,0,0.3), 0 4px 12px rgba(0,0,0,0.2); }
    p { color: #b4b4b4; }
  }`;

export const successHtml = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>Logged in to Whop</title>
  <style>${BASE_STYLES}
  </style>
</head>
<body>
  <div class="card">
    <div class="logo">${LOGO_SVG}</div>
    <h1>Logged in to Whop</h1>
    <p>You can return to your terminal.</p>
  </div>
</body>
</html>`;

export function errorHtml(error: string | null): string {
	const message = error
		? `<code>${error.replace(/</g, "&lt;").replace(/>/g, "&gt;")}</code>`
		: "An unknown error occurred.";
	return `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>Login failed</title>
  <style>${BASE_STYLES}
  code { font-size: 12px; color: #e54d2e; background: #feebe7; padding: 2px 6px; border-radius: 4px; font-family: ui-monospace, monospace; }
  @media (prefers-color-scheme: dark) {
    code { background: #391714; color: #f5a898; }
  }
  </style>
</head>
<body>
  <div class="card">
    <div class="logo">${LOGO_SVG}</div>
    <h1>Login failed</h1>
    <p>${message}</p>
  </div>
</body>
</html>`;
}
